import { render, staticRenderFns } from "./placeDialog.vue?vue&type=template&id=1168fdf7&scoped=true&"
import script from "./placeDialog.vue?vue&type=script&lang=js&"
export * from "./placeDialog.vue?vue&type=script&lang=js&"
import style0 from "./placeDialog.vue?vue&type=style&index=0&id=1168fdf7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1168fdf7",
  null
  
)

export default component.exports